import styled, { css, keyframes } from 'styled-components'
import BlinkingRobotSVG from './assets/blinking-robot.svg'

const getStepDurationMs = (animationDurationMs: number) => {
  const totalSteps = 7
  return animationDurationMs / totalSteps
}

const blink = keyframes`
  0% {
    d: path("M 235.907 154.869 L 236.071 154.869 C 238.641 154.869 240.721 156.949 240.721 159.519 L 240.721 159.709 C 240.721 162.279 238.641 164.359 236.071 164.359 L 235.881 164.359 C 233.311 164.359 231.231 162.279 231.231 159.709 L 231.231 159.519 C 231.231 156.949 233.337 154.869 235.907 154.869 Z");
  }

  10% {
    d: path("M 235.881 157.233 L 236.137 157.233 C 238.707 157.233 240.721 156.949 240.721 159.519 L 240.721 159.709 C 240.721 162.279 238.707 161.987 236.137 161.987 L 235.848 161.987 C 233.278 161.987 231.231 162.279 231.231 159.709 L 231.231 159.519 C 231.231 156.949 233.311 157.233 235.881 157.233 Z");
  }

  20% {
    d: path("M 235.907 154.869 L 236.071 154.869 C 238.641 154.869 240.721 156.949 240.721 159.519 L 240.721 159.709 C 240.721 162.279 238.641 164.359 236.071 164.359 L 235.881 164.359 C 233.311 164.359 231.231 162.279 231.231 159.709 L 231.231 159.519 C 231.231 156.949 233.337 154.869 235.907 154.869 Z");
  }

  100% {
    d: path("M 235.907 154.869 L 236.071 154.869 C 238.641 154.869 240.721 156.949 240.721 159.519 L 240.721 159.709 C 240.721 162.279 238.641 164.359 236.071 164.359 L 235.881 164.359 C 233.311 164.359 231.231 162.279 231.231 159.709 L 231.231 159.519 C 231.231 156.949 233.337 154.869 235.907 154.869 Z");
  }
`

const smile = keyframes`
  0% {
    d: path("M 193.676 178.459 C 193.676 178.459 195.819 178.459 196.569 178.459 L 233.144 178.459 C 233.894 178.459 236.062 178.459 236.062 178.459 C 238.652 178.459 240.709 180.579 240.709 183.189 L 240.709 183.259 C 240.709 185.859 238.609 187.979 236.009 187.979 L 193.569 187.979 C 190.979 187.979 188.869 185.869 188.869 183.259 L 188.869 183.189 C 188.869 180.589 191.076 178.459 193.676 178.459 Z");
  }
  
  10% {
    d: path("M 193.569 178.469 C 193.569 178.469 195.819 182.649 196.569 182.649 L 233.009 182.649 C 233.759 182.649 236.009 178.469 236.009 178.469 C 238.599 178.469 240.709 180.579 240.709 183.189 L 240.709 183.259 C 240.709 185.859 238.609 187.979 236.009 187.979 L 193.569 187.979 C 190.979 187.979 188.869 185.869 188.869 183.259 L 188.869 183.189 C 188.869 180.589 190.969 178.469 193.569 178.469 Z");
  }
  
  20% {
    d: path("M 193.676 178.459 C 193.676 178.459 195.819 178.459 196.569 178.459 L 233.144 178.459 C 233.894 178.459 236.062 178.459 236.062 178.459 C 238.652 178.459 240.709 180.579 240.709 183.189 L 240.709 183.259 C 240.709 185.859 238.609 187.979 236.009 187.979 L 193.569 187.979 C 190.979 187.979 188.869 185.869 188.869 183.259 L 188.869 183.189 C 188.869 180.589 191.076 178.459 193.676 178.459 Z");
  }
  
  100% {
    d: path("M 193.676 178.459 C 193.676 178.459 195.819 178.459 196.569 178.459 L 233.144 178.459 C 233.894 178.459 236.062 178.459 236.062 178.459 C 238.652 178.459 240.709 180.579 240.709 183.189 L 240.709 183.259 C 240.709 185.859 238.609 187.979 236.009 187.979 L 193.569 187.979 C 190.979 187.979 188.869 185.869 188.869 183.259 L 188.869 183.189 C 188.869 180.589 191.076 178.459 193.676 178.459 Z");
  }
`

const pulse = keyframes`
  0% {
    transform: scale(0.25);
  }

  25% {
    transform: scale(0.5);
  }

  50% {
    transform: scale(1);
  }

  75% {
    transform: scale(0.75);
  }
`

const spinAndShrink = keyframes`
  0% {
    transform: rotate(0deg) scale(1);
    opacity: 1;
  }

  56% {
    transform: rotate(360deg) scale(1);
    opacity: 0.75;
  }

  70% {
    transform: rotate(450deg) scale(0.75);
  }

  84% {
    transform: rotate(540deg) scale(0.37);
    opacity: 0.3;
  }
`

const resetOpacity = keyframes`
  0% {
    opacity: 1;
  }

  100% {
    opacity: initial;
  }
`

export const Container = styled.div<{ size: number }>`
  position: relative;
  width: ${({ size }) => `${size}px`};
  height: ${({ size }) => `${size}px`};
  display: flex;
  place-content: center;
`

export const Spinners = styled.div<{
  animating: boolean
  animationDurationMs: number
}>`
  transform: rotate(630deg) scale(0.17);
  opacity: ${({ animating }) => (animating ? '0.3' : '0')};
  animation: ${({ animating, animationDurationMs }) =>
    animating
      ? css`
          ${spinAndShrink} ${getStepDurationMs(animationDurationMs) *
          7}ms linear normal
        `
      : ''};
  width: 100%;
  height: 100%;

  svg {
    width: 100%;
    height: 100%;

    circle {
      animation: ${({ animationDurationMs }) => css`
        ${resetOpacity} ${getStepDurationMs(
          animationDurationMs
        )}ms linear normal
      `};
    }
  }
`

export const BlinkingRobot = styled(BlinkingRobotSVG)<{
  $animating: boolean
  $animationDurationMs: number
}>`
  ${({ $animating }) => css`
    opacity: ${$animating ? '1' : '0'};
  `}
  & path:last-child {
    animation: ${({ $animating, $animationDurationMs }) =>
      $animating
        ? css`
            ${blink} ${getStepDurationMs($animationDurationMs) *
            6}ms linear normal;
            animation-delay: ${getStepDurationMs($animationDurationMs) * 2}ms;
          `
        : ''};
  }
  & path:nth-child(3) {
    animation: ${({ $animating, $animationDurationMs }) =>
      $animating
        ? css`
            ${smile} ${getStepDurationMs($animationDurationMs) *
            6}ms linear normal;
            animation-delay: ${getStepDurationMs($animationDurationMs) * 2}ms;
          `
        : ''};
  }
  animation: ${({ $animating, $animationDurationMs }) =>
    $animating
      ? css`
          ${pulse} ${getStepDurationMs($animationDurationMs) *
          4}ms linear normal
        `
      : ''};
  animation-delay: 0s;

  transform: scale(0.75);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`
